<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :disabled="disabled"
    min-width="290px"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="text"
        @input="onTextInput"
        :label="label"
        placeholder="dd/mm/aaaa"
        prepend-icon="mdi-calendar"
        outlined
        dense
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="value"
      locale="pt-BR"
      no-title
      first-day-of-week="0"
      scrollable
      @input="onPicked"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { formatDateInput, maskDateInput, parseDateInput } from "@/utils/scheduling";

export default {
  name: "ScheduledDateField",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Data",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      text: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(next) {
        this.text = formatDateInput(next);
      },
    },
  },
  methods: {
    onTextInput(raw) {
      this.text = maskDateInput(raw);
      this.$emit("input", parseDateInput(raw));
    },
    onPicked(iso) {
      this.$emit("input", iso);
      this.menu = false;
    },
  },
};
</script>